// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__35rUZ","fullView":"styles_fullView__1VuIZ"};